import axios from 'axios';
import { Service } from '../../data_types';

const BASE_URL = process.env.REACT_APP_SERVICES_BASE_URL as string;

if (!BASE_URL) {
    throw new Error('REACT_APP_SERVICES_BASE_URL is not defined in the environment variables');
}

export const fetchServices = async (): Promise<{ services: Service[], servicesPerRow: number }> => {
    try {
        const response = await axios.get<{ services: Service[], servicesPerRow: number }>(BASE_URL, {
            withCredentials: true // Include credentials in the request
        });
        return response.data;
    } catch (error: any) {
        console.error('Failed to fetch services:', error.message);
        throw new Error('Failed to fetch services');
    }
};

export const addService = async (newService: Service): Promise<Service> => {
    try {
        const response = await axios.post<Service>(BASE_URL, newService, {
            withCredentials: true // Include credentials in the request
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to add service');
    }
};
